import { DATE_FORMATS, DATE_UNIT, DateUtils } from "shared/dateUtils";
import { PortalNews } from "shared/types";

export function shouldDisplayNews<
  T extends { lastView: string; countViews: number }
>(news: PortalNews, userRegisteredNews: T | null): boolean {
  const isNotExpired = DateUtils.parse(
    news.maxDate,
    DATE_FORMATS["YYYY-MM-DD"]
  ).isSameOrAfter(new Date(), DATE_UNIT.DAY);

  if (news.repeat === "no-repeat") {
    const neverViewed =
      userRegisteredNews == null || userRegisteredNews.countViews === 0;

    return isNotExpired && neverViewed;
  }

  if (news.repeat === "daily") {
    const wasViewedToday =
      userRegisteredNews != null &&
      DateUtils.parse(userRegisteredNews.lastView).isSame(
        new Date(),
        DATE_UNIT.DAY
      );

    return isNotExpired && !wasViewedToday;
  }

  return false;
}
